import { render, staticRenderFns } from "./EventHeroLocation.vue?vue&type=template&id=a386367c&"
import script from "./EventHeroLocation.vue?vue&type=script&lang=js&"
export * from "./EventHeroLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports